// extracted by css-extract-rspack-plugin
export default {"maskTabPanelContent":"MaskTabPanel_maskTabPanelContent__LHa4T"};